import locationApi from '../api/locationApi';
import placeModel from '../models/place';

class locationService {
  /**
   * searchType: CountryState, SubUrbOnly, NotApplicable
   * GroupScreen: using CountryState
   */
  locationAutoComplete(text, isSuburbOnly, coords, searchType) {
    const body = {};
    if (searchType || isSuburbOnly) {
      body.SearchType = searchType || (isSuburbOnly ? 'SubUrbOnly' : 'NotApplicable');
    }
    if (text) {
      body.SearchText = text;
    }
    if (coords && coords.lat && coords.lng) {
      body.Lat = coords.lat;
      body.Lon = coords.lng;
    }
    return locationApi
      .locationAutoComplete(body)
      .then(res => {
        if (res.success) {
          // return res
          if (res.data) {
            return {
              success: res.success,
              data: { data: placeModel.mappingRHPLocations(res.data.items) },
            };
          }
          return { success: res.success, data: { data: [], total: 0 } };
        }
        console.log('ERROR: locationService/locationAutoComplete:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: locationService/locationAutoComplete:', e);
        throw new Error('failed');
      });
  }

  getLocation(countryId) {
    return locationApi
      .getLocation(countryId)
      .then(res => {
        if (res.success) {
          // return res
          if (res.data) {
            return {
              success: res.success,
              data: res.data.items.map(itm => ({ id: itm.ItemID, text: itm.ItemName, count: 0, googleMapPlaceID: itm.ItemID, placesParentID: countryId })),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: locationService/getLocation:', res);
        return {
          success: res.success,
          data: [],
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: locationService/getLocation:', e);
        throw new Error('failed');
      });
  }
}

export default new locationService();
